(function () {
    window.growthbook_queue = window.growthbook_queue || [];
    window.growthbook_queue.push(_ => {
        const applyFeatureFlags = () => {
            // const featureEnabled = window._growthbook?.getFeatureValue("holdout-pdm-belli-welli", false);
            const holdoutValue = window._growthbook?.getFeatureValue("holdout-pdm-sticky-header", "OFF");

            console.log(holdoutValue, "test ----")


            // Only activate the feature if the user is not in the holdout group
            if (holdoutValue !== "holdout-q1-2026") {
                console.log('test active')
                const ann =
                    document.querySelector(".announcement-bar-section .utility-bar") ||
                    document.querySelector(".announcement-bar-section") ||
                    document.querySelector(".utility-bar");

                const hdrWrap =
                    document.querySelector(".section-header sticky-header.header-wrapper") ||
                    document.querySelector(".section-header .header-wrapper") ||
                    document.querySelector("sticky-header.header-wrapper") ||
                    document.querySelector(".section-header");

                if (!ann || !hdrWrap) return;

                const original = {
                    ann: {
                        position: ann.style.position,
                        top: ann.style.top,
                        left: ann.style.left,
                        right: ann.style.right,
                        zIndex: ann.style.zIndex,
                        width: ann.style.width,
                        transform: ann.style.transform,
                        height: ann.style.height,
                    },
                    hdr: {
                        position: hdrWrap.style.position,
                        top: hdrWrap.style.top,
                        left: hdrWrap.style.left,
                        right: hdrWrap.style.right,
                        zIndex: hdrWrap.style.zIndex,
                        width: hdrWrap.style.width,
                        transform: hdrWrap.style.transform,
                    },
                    bodyPaddingTop: document.body.style.paddingTop,
                };

                let isSticky = false;

                function px(n) {
                    return Math.max(0, Math.round(n)) + "px";
                }

                function height(el) {
                    const r = el.getBoundingClientRect();
                    return Math.round(r.height || el.offsetHeight || 0);
                }

                function applySticky() {
                    const annH = height(ann);

                    ann.style.position = "fixed";
                    ann.style.top = "0";
                    ann.style.left = "0";
                    ann.style.right = "0";
                    ann.style.width = "100%";
                    ann.style.zIndex = "10020";
                    ann.style.transform = "translateZ(0)";
                    ann.style.height = "auto";

                    hdrWrap.style.position = "fixed";
                    hdrWrap.style.top = px(annH);
                    hdrWrap.style.left = "0";
                    hdrWrap.style.right = "0";
                    hdrWrap.style.width = "100%";
                    hdrWrap.style.zIndex = "10010";
                    hdrWrap.style.transform = "translateZ(0)";

                    const hdrH = height(hdrWrap);
                    document.body.style.paddingTop = px(annH + hdrH);

                    isSticky = true;
                }

                function removeSticky() {
                    Object.assign(ann.style, original.ann);
                    Object.assign(hdrWrap.style, original.hdr);
                    document.body.style.paddingTop = original.bodyPaddingTop;
                    isSticky = false;
                }

                function update() {
                    const shouldStick = true;

                    if (shouldStick && !isSticky) applySticky();
                    else if (!shouldStick && isSticky) removeSticky();
                    else if (shouldStick && isSticky) {
                        const annH = height(ann);
                        hdrWrap.style.top = px(annH);
                        document.body.style.paddingTop = px(annH + height(hdrWrap));
                    }
                }

                let raf = null;
                function schedule() {
                    if (raf) return;
                    raf = requestAnimationFrame(() => {
                        raf = null;
                        update();
                    });
                }

                window.addEventListener("scroll", schedule, { passive: true });
                window.addEventListener("resize", schedule);
                window.addEventListener("orientationchange", schedule);
                window.addEventListener("load", schedule);

                if (document.readyState === "loading") {
                    document.addEventListener("DOMContentLoaded", schedule, { once: true });
                } else {
                    schedule();
                }

                setTimeout(schedule, 50);
                setTimeout(schedule, 250);
                setTimeout(schedule, 1000);

            }
        };


        // Run initially and whenever GrowthBook updates flag data
        applyFeatureFlags();
        document.addEventListener("growthbookdata", applyFeatureFlags);
    });
})();
